import { render } from "./DashboardPanelView.vue?vue&type=template&id=95894c1c&ts=true"
import script from "./DashboardPanelView.vue?vue&type=script&lang=ts"
export * from "./DashboardPanelView.vue?vue&type=script&lang=ts"

import "./DashboardPanelView.vue?vue&type=style&index=0&id=95894c1c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__